export default "__VITE_ASSET__B1dvrmy9__"